export function generateHID(message) {
    let sha256 = require('js-sha256');
    let hash = sha256.create()
    let cd = Date.now()
    hash.update(cd+message)
    // console.log('hash generated: ', hash.hex())
    return hash.hex()
}
export function saveClientProfileToLocal(client) {
    //save in localStorage hid
    let profile = JSON.stringify(client)
    localStorage.setItem('serpi_profile',profile)
}
export function getClientProfile() {
    return JSON.parse(localStorage.getItem('serpi_profile'))
}